module.exports = __webpack_public_path__ + "fonts/icomoon.f7a02801.eot";